import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { generalService } from '../../services/general.service';
import { Item } from '../../models/item';
import { Vehiculo } from '../../models/vehiculo';
import { MatOptionSelectionChange, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ItemSubFamily } from '../../models/item-subfamily';
import { MatSelect } from '@angular/material/select';

@Component({
    selector: 'app-add-vehicle',
    templateUrl: 'vehiculo-agregar-editar.html',
    styleUrls: [],
    providers: [generalService]
  })

  export class VehicleAddEditComponent implements OnInit {
    private vehiculo :Vehiculo = new Vehiculo();;
    public title = '';
    private loacs: string;
    private VEHICLE_ID = undefined;
    public dataVehiculo: any[] = [];
    public tipoPermiso: any[] = [];
    public configuracionVehicular: any[] = [];
    public vehicle: Item;
    public vehicleForm: FormGroup;
    public btnStatus = "";
    public nombreVehiculoTxt = "";
    public actualizar = false;
    constructor(private router: Router,private formBuilder: FormBuilder,
      private _generalService: generalService,private route: ActivatedRoute,) {
      this.vehicle = new Item();
      this.vehicleForm = new FormGroup({});
      this.VEHICLE_ID = this.route.snapshot.paramMap.get('id'); 
    }

    ngOnInit(){
      this.validateRoute();
      this.buildVehiculoForm();
      this.consultarDataVehiculos();
      
    }


    validateRoute() {
      if (this.VEHICLE_ID === 'N') {
        this.title = 'guardado';
        this.btnStatus = "Agregar";
      }else{
        this.title = 'actualizado';
        this.btnStatus = "Actualizar";
      }
    }



    backward() {
      this.router.navigate(['app/vehiculo']);
    }
    buildVehiculoForm() {    
      this.vehicleForm = this.formBuilder.group({
        // General data
        nameVehicle: this.formBuilder.control(null, [Validators.required,Validators.minLength(3), Validators.maxLength(50)]), 
        tipoPermiso: this.formBuilder.control(null, [Validators.required]),
        idVehicle: this.formBuilder.control(null), 
        numeroPermisoSCT: this.formBuilder.control(null, [Validators.required, Validators.maxLength(50)]), 
        configuracionVehicular: this.formBuilder.control(null, [Validators.required]), 
        placaVM: this.formBuilder.control(null, [Validators.required, Validators.maxLength(50)]), 
        modelo: this.formBuilder.control(null, [Validators.required, Validators.maxLength(50)]),
        poliza: this.formBuilder.control(null, [Validators.required, Validators.maxLength(50)]), 
        aseguradora: this.formBuilder.control(null, [Validators.required, Validators.maxLength(50)]),
        pesoBruto: this.formBuilder.control(null, [Validators.required, Validators.maxLength(50)]),
         
        // Not required
        
       
      });
    }
    consultarDataVehiculos(){
      
      let metodo = 'Vehiculo/consultDatavehicle';
     
      const params = { 
          loacs: sessionStorage.getItem('acslo'),
          idvehiculo:this.VEHICLE_ID
      };

      this._generalService.metodoCallParams(params, metodo).subscribe(
        result => {
          const tableResult = JSON.parse(result);
          this.tipoPermiso = tableResult.Table; 
          this.configuracionVehicular = tableResult.Table1;
          this.dataVehiculo = tableResult.Table2;
          
          if (this.dataVehiculo.length > 0){
            this.vehicleForm.get('nameVehicle').setValue(this.dataVehiculo[0].NOMBRE);
            this.vehicleForm.get('tipoPermiso').setValue(this.dataVehiculo[0].TIPO_PERMISO_SCT_ID);
            this.vehicleForm.get('numeroPermisoSCT').setValue(this.dataVehiculo[0].NUMERO_PERMISO_SCT);
            this.vehicleForm.get('configuracionVehicular').setValue(this.dataVehiculo[0].CONFIGURACION_VEHICULAR_ID);
            this.vehicleForm.get('placaVM').setValue(this.dataVehiculo[0].PLACA_VM);
            this.vehicleForm.get('modelo').setValue(this.dataVehiculo[0].MODELO);
            this.vehicleForm.get('poliza').setValue(this.dataVehiculo[0].POLIZA_RC);
            this.vehicleForm.get('aseguradora').setValue(this.dataVehiculo[0].ASEGURADORA_RC);
            this.vehicleForm.get('idVehicle').setValue(this.dataVehiculo[0].VEHICLE_ID);
            this.vehicleForm.get('pesoBruto').setValue(this.dataVehiculo[0].PESO_BRUTO);
            
            this.nombreVehiculoTxt = this.dataVehiculo[0].NOMBRE;
          } 
        },
        error => {  console.log(<any>error);  }
      );
    }
    guardarVehiculo() {
      //this. guardandoCliente = true;
      this.mapearDatosFormularioEnModelo();
        this.agregarVehiculo();
    }
    mapearDatosFormularioEnModelo() {
      this.vehiculo.nombreVehiculo = this.vehicleForm.controls['nameVehicle'].value;
      this.vehiculo.idvehiculo = this.vehicleForm.controls['idVehicle'].value;
      this.vehiculo.tipoPermisoID = this.vehicleForm.controls['tipoPermiso'].value;
      this.vehiculo.numeroPermiso = this.vehicleForm.controls['numeroPermisoSCT'].value;
      this.vehiculo.configuracionVeicularID = this.vehicleForm.controls['configuracionVehicular'].value;
      this.vehiculo.placa = this.vehicleForm.controls['placaVM'].value;
      this.vehiculo.modelo = this.vehicleForm.controls['modelo'].value;
      this.vehiculo.poliza = this.vehicleForm.controls['poliza'].value;
      this.vehiculo.aseguradora = this.vehicleForm.controls['aseguradora'].value;
      this.vehiculo.pesoBruto = this.vehicleForm.controls['pesoBruto'].value;
      
      this.vehiculo.loacs =  sessionStorage.getItem('acslo');
    }
    
    agregarVehiculo() {
      this._generalService.metodoCallParams(this.vehiculo, 'Vehiculo/addVehicle').subscribe(
        (result) => {
          this.backward();
          this._generalService.toastCall('Registro '+ this.title +' exitosamente!');
          }, (error) => {
            console.log(error as any);
          });
    }
  }

  


// WEBPACK FOOTER //
// ./src/app/vehiculo/vehiculo-agregar-editar/vehiculo-agregar-editar.ts